import { Component, OnInit, Input, OnChanges } from '@angular/core';

import { HelperService, HTTPService } from 'app/services';

@Component({
  selector: 'app-rd-bulletins',
  templateUrl: './rd-bulletins.component.html',
  styleUrls: ['./rd-bulletins.component.scss'],
})
export class RdBulletinsComponent implements OnInit, OnChanges {
  @Input() options: any = {};
  @Input() vehicleId: string = '';
  @Input() bulletins: any[] = [];
  @Input() isProcessing: boolean = false;

  isLoading: boolean = false;
  isBulletinSelected: boolean = false;
  selectedBulletinActive: any = {};
  selectedBulletin: any = {
    displayName: '',
    items: [],
  };

  constructor(
    private httpService: HTTPService,
    private helperService: HelperService
  ) {}

  ngOnInit() {
    this.fetchInitialDetails();
  }

  ngOnChanges(change: any) {
    const { isProcessing } = change;
    if (isProcessing) {
      if (isProcessing.previousValue && !isProcessing.currentValue) {
        this.fetchInitialDetails();
      }
    }
  }

  fetchInitialDetails() {
    if (this.isLoading) return;

    if (this.bulletins.length) {
      this.selectedBulletinActive = this.bulletins[0]
      this.getBulletinDetails(this.bulletins[0]);
    }
  }

  getBulletinDetails(bulletin: any) {
    this.isLoading = true;
    this.httpService
      .getBulletinDetail({
        ...this.options,
        vehicleId: this.vehicleId,
        applicationId: bulletin.applicationId,
      })
      .then(
        ({ bulletin }) => {
          if (bulletin && bulletin.items) {
            bulletin.items.forEach((item: any) => {
              const binary = atob(item.image.replace(/\s/g, ''));
              const buffer = new ArrayBuffer(binary.length);
              const view = new Uint8Array(buffer);

              for (var i = 0; i < binary.length; i++) {
                view[i] = binary.charCodeAt(i);
              }

              item.downloadLink = URL.createObjectURL(
                new Blob([view], { type: 'application/pdf' })
              );
            });

            this.selectedBulletin = bulletin;
          }
        },
        (err) => {
          this.helperService.showToaster('error', err);
        }
      )
      .finally(() => (this.isLoading = false));
  }

  openPdf(downloadLink: string) {
    window.open(downloadLink, '_blank');
  }

  handleBack() {}
}
